import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';

import Badge from '$app-web/ui-kit/components/badge';

import classes from './styles.module.scss';

const Avatar = (props) => {
    const { badge, children, color, colorValue, label, online, size, src, clickable } = props;

    const style = {};

    if (!src && colorValue !== undefined) {
        style.backgroundColor = colorValue;
    }

    return (
        <div
            className={clsx(classes.root, classes[size], {
                [classes.clickable]: clickable,
                // TODO: Add support for all colors after the color system became consistent
                [classes.ocean]: src === undefined && color === 'ocean',
                [classes.space]: src === undefined && color === 'space',
                [classes.gray]: src === undefined && color === 'gray',
                [classes.green]: src === undefined && color === 'green',
                [classes.red]: src === undefined && color === 'red',
                [classes.yellow]: src === undefined && color === 'yellow',
                [classes.orange]: src === undefined && color === 'orange',
                [classes.turquoise]: src === undefined && color === 'turquoise',
                [classes.violet]: src === undefined && color === 'violet',
                [classes.snow]: src === undefined && color === 'snow',
                [classes.oceanLight]: src === undefined && color === 'ocean-light',
                [classes.redLight]: src === undefined && color === 'red-light',
                [classes.orangeLight]: src === undefined && color === 'orange-light',
                [classes.tempGray]: src === undefined && color === 'temp-gray',
            })}
            style={style}
        >
            {src && <img src={src} className={classes.image} alt="" />}
            {!src && children && <div className={classes.childrenWrapper}>{children}</div>}
            {!src && !children && label && (
                <div className={clsx('flex items-center justify-center', classes.labelWrapper)}>{label[0].toUpperCase()}</div>
            )}
            {badge && <Badge border className={classes.badge} variant="dot" color="red" />}
            {online !== undefined && (
                <div
                    className={clsx(classes.status, {
                        [classes.online]: online,
                    })}
                />
            )}
        </div>
    );
};

Avatar.defaultProps = {
    children: undefined,
    color: undefined,
    clickable: false,
    colorValue: undefined,
    label: '',
    online: undefined,
    size: 'md',
    src: undefined,
};

Avatar.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    color: PropTypes.oneOf([
        'ocean',
        'space',
        'gray',
        'green',
        'red',
        'yellow',
        'orange',
        'turquoise',
        'violet',
        'snow',
        'ocean-light',
        'red-light',
        'orange-light',
        'temp-gray',
    ]),
    clickable: PropTypes.bool,
    colorValue: PropTypes.string,
    label: PropTypes.string,
    online: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'fill']),
    src: PropTypes.string,
};

export default Avatar;
